import apiClient from './client'
import type {
  LoginRequest,
  LoginResponse,
  ValidCallbackRequest,
  ValidInitResponse,
} from '@/types/api'

export const authApi = {
  login(data: LoginRequest) {
    return apiClient.post<LoginResponse>('/auth/login', data)
  },

  logout() {
    return apiClient.post('/auth/logout')
  },

  validInit() {
    return apiClient.get<ValidInitResponse>('/auth/valid/init')
  },

  validCallback(data: ValidCallbackRequest) {
    return apiClient.post<LoginResponse>('/auth/valid/callback', data)
  },
}
